import React, { useContext } from 'react';
import { ReactComponent as EmailFieldIcon } from '@ubeya/shared-web/assets/email.svg';
import { PromptClick, CircleIcon } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const InviteCRMAdminRenderer = ({ onInvite, isDisabled }) => {
  const { t } = useContext(ConfigContext);
  return (
    <PromptClick onClick={onInvite} body="areYouSureYouWantToInviteCRMAdmin" confirmText="send" usePortal>
      <CircleIcon isDisabled={isDisabled} tooltip={t('inviteAdminDisabled')} icon={EmailFieldIcon} />
    </PromptClick>
  );
};

export default InviteCRMAdminRenderer;
